module.exports = __webpack_public_path__ + "media/svg-new/logo-maxia-5558b295.svg";